import * as yup from 'yup';

export const memoryGrowthDetectionValidationSchema = yup.object({
  enabled: yup.boolean().required(),
});
